document.addEventListener("DOMContentLoaded", function () {
  const animatedItems = document.querySelectorAll(
    ".qa-reveal, .qa-fade-up, .qa-fade-in, .qa-scale-in, .qa-slide-left, .qa-slide-right"
  );

  if (!animatedItems.length) return;

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      function (entries, observerInstance) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("qa-visible");
            observerInstance.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    animatedItems.forEach(function (item) {
      observer.observe(item);
    });
  } else {
    animatedItems.forEach(function (item) {
      item.classList.add("qa-visible");
    });
  }
});